// Libraries
import { useTranslation } from 'react-i18next';

// MUI
import { Attachment } from '@mui/icons-material';

// Core
import { ResourceTextApplication } from '../../core/resources';

// Common
import { AIconButtonBaseProps, ADefaultIconButton } from '../buttons';

export interface AAttachmentIconButtonProps extends AIconButtonBaseProps {}

export default function AAttachmentIconButton(props: AAttachmentIconButtonProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral']);
    const { tooltip, ...buttonProps } = props;
    const tooltip2 = tooltip ? tooltip : t('AnelmaGeneral:1075');

    return <ADefaultIconButton {...buttonProps} icon={<Attachment />} tooltip={tooltip2} />;
}
